import { TemaCard } from 'src/data/models/TemaCardModel';

export const foodCards: TemaCard[] = [
    // 🛒 Grocery shopping
    new TemaCard(
        'food1',
        'Food',
        'word',
        'fruta',
        'fruit',
        'Basic grocery vocabulary.',
        [
            { spanish: 'manzana', english: 'apple' },
            { spanish: 'plátano', english: 'banana' },
            { spanish: 'naranja', english: 'orange' },
            { spanish: 'sandía', english: 'watermelon' },
            { spanish: 'fresa', english: 'strawberry' },
            { spanish: 'pera', english: 'pear' },
            { spanish: 'kiwi', english: 'kiwi' },
        ]
    ),
    new TemaCard(
        'food2',
        'Food',
        'word',
        'pan',
        'bread',
        'Common staple in meals.',
        [
            { spanish: 'pan integral', english: 'whole grain bread' },
            { spanish: 'bollería', english: 'pastries' },
            { spanish: 'baguette', english: 'baguette' },
            { spanish: 'pan de ajo', english: 'garlic bread' },
            { spanish: 'pan de molde', english: 'sliced bread' },
        ]
    ),
    new TemaCard(
        'food3',
        'Food',
        'word',
        'leche',
        'milk',
        'Common dairy product.',
        [
            { spanish: 'leche descremada', english: 'skim milk' },
            { spanish: 'leche de almendras', english: 'almond milk' },
            { spanish: 'leche de avena', english: 'oat milk' },
        ]
    ),
    new TemaCard(
        'food4',
        'Food',
        'word',
        'verduras',
        'vegetables',
        'Basic vegetable vocabulary.',
        [
            { spanish: 'lechuga', english: 'lettuce' },
            { spanish: 'tomate', english: 'tomato' },
            { spanish: 'zanahoria', english: 'carrot' },
            { spanish: 'pepino', english: 'cucumber' },
            { spanish: 'pimiento', english: 'pepper' },
            { spanish: 'espinaca', english: 'spinach' },
        ]
    ),

    // 🍽️ Dining Out
    new TemaCard(
        'food5',
        'Food',
        'phrase',
        '¿Tienen una mesa para dos?',
        'Do you have a table for two?',
        'Common when arriving at a restaurant.'
    ),
    new TemaCard(
        'food6',
        'Food',
        'sentence',
        'Quisiera hacer una reserva para esta noche.',
        'I’d like to make a reservation for tonight.',
        'Polite way to book a table.'
    ),
    new TemaCard(
        'food7',
        'Food',
        'sentence',
        '¿Nos puede traer el menú, por favor?',
        'Can you bring us the menu, please?',
        'Standard request to the waiter.'
    ),
    new TemaCard(
        'food8',
        'Food',
        'sentence',
        '¿Tienen menú vegetariano?',
        'Do you have a vegetarian menu?',
        'Useful for those following a vegetarian diet.'
    ),

    // 🧾 Ordering Food
    new TemaCard(
        'food9',
        'Food',
        'sentence',
        'Voy a tomar la paella.',
        'I’ll have the paella.',
        'Used to place an order.'
    ),
    new TemaCard(
        'food10',
        'Food',
        'phrase',
        '¿Qué recomienda?',
        'What do you recommend?',
        'Ask this to the waiter for a local dish.'
    ),
    new TemaCard(
        'food11',
        'Food',
        'word',
        'carne',
        'meat',
        'Main protein categories.',
        [
            { spanish: 'pollo', english: 'chicken' },
            { spanish: 'ternera', english: 'beef' },
            { spanish: 'cerdo', english: 'pork' },
            { spanish: 'cordero', english: 'lamb' },
            { spanish: 'pavo', english: 'turkey' },
            { spanish: 'bacon', english: 'bacon' },
        ]
    ),
    new TemaCard(
        'food12',
        'Food',
        'word',
        'pescado',
        'fish',
        'Common protein category in many cultures.',
        [
            { spanish: 'salmón', english: 'salmon' },
            { spanish: 'atún', english: 'tuna' },
            { spanish: 'bacalao', english: 'cod' },
            { spanish: 'sardina', english: 'sardine' },
        ]
    ),
    new TemaCard(
        'food13',
        'Food',
        'word',
        'ensalada',
        'salad',
        'Basic food vocabulary.',
        [
            { spanish: 'lechuga', english: 'lettuce' },
            { spanish: 'tomate', english: 'tomato' },
            { spanish: 'aceite de oliva', english: 'olive oil' },
            { spanish: 'vinagre', english: 'vinegar' },
            { spanish: 'aguacate', english: 'avocado' },
        ]
    ),

    // ⚠️ Dietary Restrictions & Allergies
    new TemaCard(
        'food14',
        'Food',
        'sentence',
        'Soy alérgico a los frutos secos.',
        'I’m allergic to nuts.',
        'Critical for health and safety.'
    ),
    new TemaCard(
        'food15',
        'Food',
        'sentence',
        '¿Este plato contiene gluten?',
        'Does this dish contain gluten?',
        'Useful for dietary restrictions.'
    ),
    new TemaCard(
        'food16',
        'Food',
        'sentence',
        'Soy vegano/a.',
        'I am vegan.',
        'For those who follow a vegan diet.'
    ),
    new TemaCard(
        'food17',
        'Food',
        'sentence',
        '¿Este plato contiene lácteos?',
        'Does this dish contain dairy?',
        'Essential for those avoiding dairy.'
    ),
    new TemaCard(
        'food18',
        'Food',
        'sentence',
        '¿Este plato es picante?',
        'Is this dish spicy?',
        'Useful for people who avoid spicy food.'
    ),
    new TemaCard(
        'food19',
        'Food',
        'sentence',
        'Soy intolerante a la lactosa.',
        'I’m lactose intolerant.',
        'For those who need to avoid lactose.'
    ),

    // 🧾 Paying the Bill
    new TemaCard(
        'food20',
        'Food',
        'phrase',
        '¿Nos puede traer la cuenta?',
        'Can you bring us the bill?',
        'Standard phrase to request the check.'
    ),
    new TemaCard(
        'food21',
        'Food',
        'sentence',
        '¿Se puede pagar con tarjeta?',
        'Can I pay by card?',
        'Important when cashless.'
    ),
    new TemaCard(
        'food22',
        'Food',
        'phrase',
        '¿Puedo dividir la cuenta?',
        'Can I split the bill?',
        'Useful if dining with multiple people.'
    ),

    // 🍷 Drinks & Beverages
    new TemaCard(
        'food23',
        'Food',
        'word',
        'bebida',
        'drink',
        'Common vocabulary for beverages.',
        [
            { spanish: 'agua', english: 'water' },
            { spanish: 'vino', english: 'wine' },
            { spanish: 'cerveza', english: 'beer' },
            { spanish: 'refresco', english: 'soda' },
            { spanish: 'té', english: 'tea' },
            { spanish: 'café', english: 'coffee' },
            { spanish: 'zumo', english: 'juice' },
        ]
    ),
    new TemaCard(
        'food24',
        'Food',
        'phrase',
        '¿Me puede traer una copa de vino?',
        'Can you bring me a glass of wine?',
        'Common for wine orders.'
    ),
    new TemaCard(
        'food25',
        'Food',
        'phrase',
        '¿Tienen jugo natural?',
        'Do you have fresh juice?',
        'Common phrase for non-alcoholic drink orders.'
    ),

    // 🍽️ Additional Useful Phrases
    new TemaCard(
        'food26',
        'Food',
        'phrase',
        '¿Hay un menú para niños?',
        'Is there a kids’ menu?',
        'Useful when dining with children.'
    ),
    new TemaCard(
        'food27',
        'Food',
        'phrase',
        '¿Este plato viene con arroz?',
        'Does this dish come with rice?',
        'Helpful when you want to check if rice is included.'
    ),
    new TemaCard(
        'food28',
        'Food',
        'phrase',
        '¿Puedo ver la carta de vinos?',
        'Can I see the wine list?',
        'Useful when you’re interested in the wine selection.'
    ),
];
